import { DBDocObject } from '../../../objects/generic/db-doc/db-doc-object';

export abstract class DBAction<T extends DBDocObject> {}
